import { Link, navigate } from "gatsby"
import React from "react"

import { isLoggedIn, logout } from "../../../utils/auth"
import { menuLink, submenuLink } from "./account.module.css"
const Account = ({ openTab }) => {
  return (
    <div className={openTab === 2 ? "block" : "hidden"} id="link2">
      <ul className={menuLink}>
        {!isLoggedIn() ? (
          <>
            <li>
              {" "}
              <Link to="/login">Log in</Link>
            </li>
            <li>
              {" "}
              <Link to="/register">Register</Link>
            </li>
          </>
        ) : (
          <>
            <li>
              <button
                className=" text-left p-2 w-full block hover:bg-black hover:text-white"
                onClick={event => {
                  event.preventDefault()
                  logout().then(() => navigate("/login"))
                }}
              >
                Log Out
              </button>
            </li>
            <ul className={submenuLink}>
              <Link
                className="border-b p-2 block hover:bg-black hover:text-white"
                to="/customer/account"
              >
                My Account
              </Link>
              <li>
                {" "}
                <Link to="/customer/account">account</Link>
              </li>
              <li>
                {" "}
                <Link to="/customer/address">address</Link>
              </li>
              <li>
                {" "}
                <Link to="/customer/info">information</Link>
              </li>
              <li>
                {" "}
                <Link to="/customer/order">orders</Link>
              </li>
            </ul>
          </>
        )}
      </ul>
    </div>
  )
}

export default Account
